var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "play-b",
    cx: 24,
    cy: 24,
    r: 20
  }), /*#__PURE__*/React.createElement("filter", {
    id: "play-a",
    width: "132.5%",
    height: "132.5%",
    x: "-16.2%",
    y: "-13.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#play-a)",
    xlinkHref: "#play-b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.5,
    fill: "#FFF",
    stroke: "#EFEFEF",
    strokeLinejoin: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f48e7",
    d: "M20.437098,16.7894942 C20.6221578,16.7894942 20.8035877,16.8408465 20.9611954,16.9378359 L31.0531532,23.1482715 C31.5235111,23.4377225 31.6701651,24.0536693 31.3807141,24.5240272 C31.2986708,24.6573476 31.1864737,24.7695447 31.0531532,24.8515881 L20.9611954,31.0620237 C20.4908375,31.3514747 19.8748907,31.2048207 19.5854397,30.7344628 C19.4884503,30.5768551 19.437098,30.3954251 19.437098,30.2103653 L19.437098,17.7894942 C19.437098,17.2372094 19.8848132,16.7894942 20.437098,16.7894942 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.308cdbe0d57b6ddf10924b3853cf0536.svg";
export { ForwardRef as ReactComponent };